import React, { useEffect, useState } from 'react'
import TitlebarAction from '../common/TitlebarActions'
import { getArea } from '../../services/company.service'
import { AreaForm } from '../../models/area.model'
import MainContainer from '../common/MainContainer'
import AreaCreateForm from '../AreaCreateForm'
import { useNavigate } from 'react-router-dom'
import { useProject } from '../../context/ProjectContext'
import { useNotification } from '../../context/NotificationContext'


interface AreaViewProps {
  area_code: string,
  setBlockScreen: (p: any) => void,
}

const AreaView: React.FC<AreaViewProps> = ({
  area_code,
  setBlockScreen,
}) => {
  const { selectedProject } = useProject()
  const { showNotification } = useNotification();
  
  const navigate = useNavigate()
  const [name, setName] = useState<string>('')
  const [areaForm, setAreaForm] = useState<AreaForm>({
    name: '',
    created_date: '',
    phone_number: '',
    description: '',
    company: { id: '', label: '' },
    notifs: [],
    emails: [],
    discords: []
  })

  const initComponent = () => {
    setBlockScreen(true);
    Promise.all([getArea(selectedProject, area_code)]).then(function (results) {
      setAreaForm(results[0]);
      setBlockScreen(false);
      setName(results[0].name);
    }).catch((error) => {
      showNotification(error.response.data)
      setBlockScreen(false);
      setTimeout(() => navigate('/areas/listing'), 1500)
    });
    setBlockScreen(false)
  }

  useEffect(initComponent, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setAreaForm({
      ...areaForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSelection = (key: string, value: string): void => {
    setAreaForm({
      ...areaForm,
      [key]: value
    });
  }

  return (<>
    <TitlebarAction title={`Área: ${name}`} />
    <MainContainer>
      <AreaCreateForm
        area_code={area_code}
        setBlockScreen={setBlockScreen}
        action='view'
        areaForm={areaForm}
        handleChange={handleChange}
        handleSelection={handleSelection}
      />
    </MainContainer>
  </>);
}

export default AreaView;
